module.exports = __webpack_public_path__ + "static/media/cattle-drones-drone-2.86e3af60.jpg";